/**
 * Describe Sequelize model for notification object.
 */
import {AbstractModel} from '../../shared/abstract.model';

// TODO: delete legacy models once the new update system has been deployed
export class LegacyAppVersion extends AbstractModel {
  customizedTenants?: number[];
  generalDescription: string;
  tenantSpecificDescription: LegacyTenantDescription[];
  vivoDescription: string;
  forcedUpdate: boolean;
  resetCache: boolean;
  versionNumber: string;
}

export interface LegacyTenantDescription {
  tenantId: number;
  description: string;
}
